import '../styles/Footer.css'

export default function Footer() {
    return(
        <div className="footer">
            Hola, Test 2
        </div>
    )
}